import { Stack, Text } from '@etg/wings';
import SegmentPassCard from './SegmentPassCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SegmentPassList = ({
  segments,
  labels,
  isMultiStop,
  onToggle,
  onSeeDetails
}) => {
  const withIndex = segments.map((segment, index) => ({
    segment,
    index
  })).filter(({
    segment
  }) => segment.available);
  const renderRows = rows => /*#__PURE__*/_jsx(Stack, {
    spacing: 8,
    children: rows.map(({
      segment,
      index
    }) => /*#__PURE__*/_jsx(SegmentPassCard, {
      index: index,
      labels: labels,
      onSeeDetails: onSeeDetails,
      onToggle: onToggle,
      segment: segment
    }, index))
  });
  if (isMultiStop) {
    return renderRows(withIndex);
  }
  const departing = withIndex.filter(({
    segment
  }) => segment.customerBoundIndex0Based === 0);
  const returning = withIndex.filter(({
    segment
  }) => segment.customerBoundIndex0Based > 0);
  const renderGroup = (heading, rows) => rows.length > 0 && /*#__PURE__*/_jsxs(Stack, {
    spacing: 16,
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "14-bold",
      children: heading
    }), renderRows(rows)]
  });
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 16,
    children: [renderGroup(labels.departing, departing), renderGroup(labels.return, returning)]
  });
};
export default SegmentPassList;
//# sourceMappingURL=SegmentPassList.js.map